module.exports = __webpack_public_path__ + "static/visit-williamsburg-logo-a37ce3f32d1ad65c38b2ff364e6f101d.png";